/* tslint:disable */
/* eslint-disable */
/**
 * MHB2B Contract API specs
 * MHB2B Contract API specs for middleware and frontend components about Forms and its variety of usages. Forms are supporting multiple field configurations forms (e.g. for Company address input form, Company input form, etc.). We agreed to cover create / update / delete usecases with generic service operations which are also capable to serve multiple future clients (e.g. browser & mobile) at the same time.
 *
 * The version of the OpenAPI document: 1.61.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI } from './base';
/**
 * Enumerated type of field tooltip
 * @export
 * @enum {string}
 */
export const FieldTooltipType = {
    Info: 'INFO'
};
/**
 * Enumerated type of Field usage for which is the field inside company used for
 * @export
 * @enum {string}
 */
export const FieldUsageType = {
    Mandatory: 'MANDATORY',
    Optional: 'OPTIONAL',
    Undefined: 'UNDEFINED'
};
/**
 * Type of transition applied to a given form sub-structure (e.g. `Positions` or `Field`) rendering state leading to a new/modified form sub-structure
 * @export
 * @enum {string}
 */
export const FormTransition = {
    VisibleTrue: 'VISIBLE_TRUE',
    VisibleFalse: 'VISIBLE_FALSE',
    MandatoryTrue: 'MANDATORY_TRUE',
    MandatoryFalse: 'MANDATORY_FALSE',
    MandatoryDefault: 'MANDATORY_DEFAULT',
    ModifiableTrue: 'MODIFIABLE_TRUE',
    ModifiableFalse: 'MODIFIABLE_FALSE',
    ModifiableDefault: 'MODIFIABLE_DEFAULT',
    SelectTrue: 'SELECT_TRUE',
    SelectFalse: 'SELECT_FALSE',
    Clear: 'CLEAR'
};
/**
 * Enumerated type of notification
 * @export
 * @enum {string}
 */
export const NotificationType = {
    Info: 'INFO',
    Warn: 'WARN',
    Error: 'ERROR'
};
/**
 * Enumerated position type of form position
 * @export
 * @enum {string}
 */
export const PositionType = {
    Checkbox: 'checkbox',
    Dropdown: 'dropdown',
    Group: 'group',
    Notification: 'notification',
    Placeholder: 'placeholder',
    RadioButton: 'radio_button',
    Text: 'text'
};
export const PositionsAlignmentEnum = {
    Horizontal: 'horizontal',
    Vertical: 'vertical'
};
/**
 * Enumerated type of Rule engines that may be applied on client or server layer
 * @export
 * @enum {string}
 */
export const RuleEngineType = {
    BeSpel: 'BE_SPEL',
    FeJsonRule: 'FE_JSON-RULE'
};
/**
 * FormsApi - axios parameter creator
 * @export
 */
export const FormsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get form fields by Keys via POST method. We agreed to never use the \"GET\" method on HTTP even if we semantically want just to retrieve data based on a given identifier. This is technically still be a POST method containing an array of form keys in the message body. The locale is extracted from HTTP headers.
         * @param {FormsRequest} formsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormsByKeys: (formsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'formsRequest' is not null or undefined
            assertParamExists('getFormsByKeys', 'formsRequest', formsRequest);
            const localVarPath = `/forms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(formsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * FormsApi - functional programming interface
 * @export
 */
export const FormsApiFp = function (configuration) {
    const localVarAxiosParamCreator = FormsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get form fields by Keys via POST method. We agreed to never use the \"GET\" method on HTTP even if we semantically want just to retrieve data based on a given identifier. This is technically still be a POST method containing an array of form keys in the message body. The locale is extracted from HTTP headers.
         * @param {FormsRequest} formsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormsByKeys(formsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getFormsByKeys(formsRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * FormsApi - factory interface
 * @export
 */
export const FormsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FormsApiFp(configuration);
    return {
        /**
         *
         * @summary Get form fields by Keys via POST method. We agreed to never use the \"GET\" method on HTTP even if we semantically want just to retrieve data based on a given identifier. This is technically still be a POST method containing an array of form keys in the message body. The locale is extracted from HTTP headers.
         * @param {FormsRequest} formsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormsByKeys(formsRequest, options) {
            return localVarFp.getFormsByKeys(formsRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FormsApi - object-oriented interface
 * @export
 * @class FormsApi
 * @extends {BaseAPI}
 */
export class FormsApi extends BaseAPI {
    /**
     *
     * @summary Get form fields by Keys via POST method. We agreed to never use the \"GET\" method on HTTP even if we semantically want just to retrieve data based on a given identifier. This is technically still be a POST method containing an array of form keys in the message body. The locale is extracted from HTTP headers.
     * @param {FormsRequest} formsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    getFormsByKeys(formsRequest, options) {
        return FormsApiFp(this.configuration).getFormsByKeys(formsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
//# sourceMappingURL=api.js.map